import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createPurchaseOrder(data) {
    let response = await apiCall("purchase_orders/create", data);
    return response;
  },
  async fetchPurchaseOrders(data) {
    let response = await apiCall("purchase_orders/list_purchase_orders", data);
    return response;
  },
  async fetchPurchaseOrderMini_data(data) {
    let response = await apiCall("purchase_orders/list_orders_mini_data", data);
    return response;
  },
  async fetchPurchaseOrderItems(data) {
    let response = await apiCall(
      "purchase_orders/get_purchase_order_items",
      data
    );
    return response;
  },
  async fetchPurchaseOrderDetails(data) {
    let response = await apiCall(
      "purchase_orders/get_purchase_order_details",
      data
    );
    return response;
  },
};
